import dingSound from '~/assets/aud/livechat-129007.mp3';

class SoundService {

  constructor() {
    
    this.ding = new Audio(dingSound);
    this.ding.volume = 0.5;
    this.ding.preload = 'auto';

    this.unlocked = false;
    this.lastPlay = 0;
    this.cooldown = 400;
    window.addEventListener('click', this.unlockAudio.bind(this), { once: true });
    window.addEventListener('keydown', this.unlockAudio.bind(this), { once: true });
    window.addEventListener('touchstart', this.unlockAudio.bind(this), { once: true });

  }

  unlockAudio() {
    if (this.unlocked) return;
    this.unlocked = true;
    const originalVolume = this.ding.volume;
    this.ding.volume = 0;
    this.ding.play()
      .then(() => {
        this.ding.pause();
        this.ding.currentTime = 0;
        this.ding.volume = originalVolume;
      })
      .catch(() => {
        this.ding.volume = originalVolume;
      });
  }

  playDing() {
    const now = Date.now();
    if (now - this.lastPlay < this.cooldown) return;
    this.lastPlay = now;
    const sound = this.ding.cloneNode(true);
    sound.volume = this.ding.volume;
    sound.play().catch((err) => {console.warn('Som bloqueado pelo navegador:', err)});
  }

}

export default new SoundService();